<agr-summary-card [title]="'BFP.UI.Widget.Title' | translate" [actions]="actions">
  @if (sortedFields().length > 0) {
    <mat-table [dataSource]="dataSource()">
      <!-- Perceel (Field Name) Column -->
      <ng-container matColumnDef="perceel">
        <mat-header-cell *matHeaderCellDef class="crop-field">
          {{ 'BFP.UI.Widget.CropField' | translate }}</mat-header-cell
        >
        <mat-cell *matCellDef="let field">
          <div class="nutrient-column">
            {{ field.name }}
            <br />
            <span class="text--gray"
              >{{ field.areaInHectares | number: '1.2' }} {{ 'hectares' | translate | lowercase }}</span
            >
          </div>
        </mat-cell>
      </ng-container>

      <!-- Bemonstring (Sampling Date) Column -->
      <ng-container matColumnDef="bemonstring">
        <mat-header-cell *matHeaderCellDef class="sample-date">
          {{ 'BFP.UI.Widget.Sampledate' | translate }}</mat-header-cell
        >
        <mat-cell *matCellDef="let field" class="date-size">
          {{ field.latestSampleDate | date: 'EE dd/MM' : undefined : locale | titlecase }}
        </mat-cell>
      </ng-container>

      <!-- Nutrient Columns -->
      <ng-container matColumnDef="nutrient1">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let field" class="nutrient-box fit-content">
          <div class="nutrients-column">
            <span class="nutrient-box left" [ngClass]="field.nutrientCalculation.n?.color"> N </span>
            <span class="nutrient-box left" [ngClass]="field.nutrientCalculation.k?.color"> K </span>
            <span class="nutrient-box left" [ngClass]="field.nutrientCalculation.mg?.color"> MgO </span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nutrient2">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>

        <mat-cell *matCellDef="let field" class="nutrient-box fit-content">
          <div class="nutrients-column">
            <span class="nutrient-box" [ngClass]="field.nutrientCalculation.mn?.color"> Mn </span>
            <span class="nutrient-box" [ngClass]="field.nutrientCalculation.b?.color"> B </span>
            <span class="nutrient-box" [ngClass]="field.nutrientCalculation.s?.color"> S </span>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Table Header and Row Definitions -->
      <mat-header-row
        *matHeaderRowDef="['perceel', 'bemonstring', 'nutrient2']"
        class="header flex--row flex--align-center"
      ></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="pointer"
        (click)="openCropfieldInfo(row)"
        (keydown.enter)="openCropfieldInfo(row)"
      ></mat-row>
    </mat-table>
  } @else {
    <app-empty-widget [text]="'BFP.UI.Widget.EmptyWidgetText' | translate" />
  }
</agr-summary-card>
